module.exports = __webpack_public_path__ + "img/shipment_delivery.e1b16336.png";